import React from 'react';
import styles from '../../styles/screens/PrasadBox/PBBenefits.module.css';
import DecorateFlower from "../../assets/prasad_gift/DecorateFlower.png";
import PrasadBox from '../../assets/holiprasad/db.png';

const PBBenefits = ({ productId }) => {
  const title = productId === "vrindavan-prasad-box" ? "Vrindavan" : "Ayodhya";

  return (
    <div className={styles.benefitsContainer}>
      <div className={styles.backgroundDecoration}>
        <img
          src={DecorateFlower}
          alt="Decorative mandala background"
          fill
          className={styles.mandalaImage}
        />
      </div>

      <h1 className={styles.mainTitle}>{`Benefits of ${title} Prasad Box`}</h1>
      <div className={styles.titleUnderline}></div>

      <div className={styles.contentContainer}>
        <div className={styles.leftSection}>
          <div className={styles.boxImageContainer}>
            <img
              src={PrasadBox}
              alt={`${title} Prasad Box`}
              width={500}
              height={500}
              className={styles.boxImage}
            />
          </div>

          <div className={styles.leftBenefits}>
            <div className={styles.benefitItem}>
              <h2 className={styles.benefitTitle}>Authenticity &amp; Divine Connection</h2>
              <p className={styles.benefitDescription}>
                {productId === "vrindavan-prasad-box"
                  ? "Sourced directly from the holy town of Vrindavan and prasad offered to Lord Krishna and Radha Rani at Banke Bihari Temple, Vrindavan"
                  : "Sourced directly from the holy town of Ayodhya and prasad offered to Shri Ramji and Hanumanji Maharaj at Hanuman Garhi, Ayodhya"
                }
              </p>
            </div>

            <div className={styles.benefitItem}>
              <h2 className={styles.benefitTitle}>True and Transparency</h2>
              <p className={styles.benefitDescription}>
                Every Box is carefully packed and blessed, ensuring it reaches you in perfect condition.
              </p>
            </div>
          </div>
        </div>

        <div className={styles.rightSection}>
          <div className={styles.benefitItem}>
            <h2 className={styles.benefitTitle}>
              {productId === "vrindavan-prasad-box"
                ? "Spiritual Blessings in your home"
                : "Removal Of Obstacles"
              }
            </h2>
            <p className={styles.benefitDescription}>
              {productId === "vrindavan-prasad-box"
                ? "Bring home items blessed in the holy land where Krishna performed His leelas."
                : "Eliminating barriers to physical well-being, professional success, and personal growth for a balanced and fulfilling life."
              }
            </p>
          </div>

          <div className={styles.benefitItem}>
            <h2 className={styles.benefitTitle}>Perfect for Gifting</h2>
            <p className={styles.benefitDescription}>
              {productId === "vrindavan-prasad-box"
                ? "Share the divine blessings of Shri Krishna with your loved ones through a thoughtfully curated Prasad Box."
                : "Share the divine blessings of Shri Ramji and Hanumanji Maharaj with your loved ones through this thoughtfully curated Prasad Box."
              }
            </p>
          </div>

          <div className={styles.benefitItem}>
            <h2 className={styles.benefitTitle}>Symbol of Devotion</h2>
            <p className={styles.benefitDescription}>
              {productId === "vrindavan-prasad-box"
                ? "Each item is a reminder of your devotion and connection to Shri Krishna and Vrindavan"
                : "Each sacred item is a reminder of your devotion and connection to Shri Ramji and Hanumanji Maharaj and Ayodhya"
              }
            </p>
          </div>

          <div className={styles.benefitItem}>
            <h2 className={styles.benefitTitle}>
              {productId === "vrindavan-prasad-box"
                ? "Strength and Vitality"
                : "Spiritual Blessings in your home"
              }
            </h2>
            <p className={styles.benefitDescription}>
              {productId === "vrindavan-prasad-box"
                ? "Praying for protection from diseases, epidemics, and health hazards"
                : "Bring home the purity and devotion of Ayodhya, the land of Shri Ramji and Hanumanji Maharaj."
              }
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PBBenefits;
